import { QrCodeEntity } from '@/domain/entities/users';
import { UsersRepository } from '@/domain/ports/users/repositories';

export class GenerateQRCodeUseCase {
  constructor(private readonly repository: UsersRepository) {}

  async run(): Promise<QrCodeEntity> {
    const data = await this.repository.generateQRCode();

    return data;
  }
}
